// extracted by mini-css-extract-plugin
export var pollAfterCardSlot = "PollContainer-module--pollAfterCardSlot--113b8";
export var pollAfterVoteSlot = "PollContainer-module--pollAfterVoteSlot--d366d";
export var pollBeforeCardSlot = "PollContainer-module--pollBeforeCardSlot--a4215";
export var pollQuestionsSlot = "PollContainer-module--pollQuestionsSlot--ff5db";
export var pollSkipButtonSlot = "PollContainer-module--pollSkipButtonSlot--181dd";
export var pollStartScreenSlot = "PollContainer-module--pollStartScreenSlot--6aed4";